import { Component, EventEmitter, Input, Output } from '@angular/core';
import { headerSetting } from 'src/_lib/interfaces/homepagesettings.interface';
import { AppConstants } from 'src/app/app.constants';
import { environment } from 'src/environments/environment.prod';
import { HeaderSearchComponent } from '../header-search/header-search.component';
import { HeaderLogoComponent } from '../header-logo/header-logo.component';
import { HeaderNavComponent } from '../header-nav/header-nav.component';
import { ShopByVehicleComponent } from 'src/app/templates/shop-by-vehicle-btn/shop-by-vehicle.component';
import { HeaderCartSectionComponent } from '../header-cart-section/header-cart-section.component';
import { HeaderContactUsSectionComponent } from '../header-contact-us-section/header-contact-us-section.component';
import { HeaderSidebarMenuComponent } from '../header-sidebar-menu/header-sidebar-menu.component';
import { HeaderMobileMenuComponent } from '../header-mobile-menu/header-mobile-menu.component';
import { ShoppingCartComponent } from '../header-cart-section/shopping-cart/shopping-cart.component';
import { NgClass, NgIf } from '@angular/common';
import { RouterLink } from "@angular/router";
import { HeaderThirdRowComponent } from '../header-third-row/header-third-row.component';
import { HeaderPromotionComponent } from '../header-promotion/header-promotion.component';

@Component({
  selector: 'app-header-ch4',
  templateUrl: './header-ch4.component.html',
  styleUrls: ['./header-ch4.component.scss'],
  standalone: true,
  imports: [HeaderSearchComponent, HeaderMobileMenuComponent, ShoppingCartComponent, HeaderLogoComponent, HeaderNavComponent, ShopByVehicleComponent, HeaderCartSectionComponent, HeaderContactUsSectionComponent, HeaderSidebarMenuComponent, NgClass, NgIf, ShopByVehicleComponent, RouterLink, HeaderThirdRowComponent,HeaderPromotionComponent]
})
export class HeaderCh4Component {
  cdnImagePath: string = environment.cdnImagePath;
  showdowntooltip: boolean = true;
  isSidebarOpen: boolean;
  firstObj: number = this.appConstants.firstObj;
  chTheme4 = environment.chTheme4;

  @Input() headerSettings: headerSetting<string> = null;
  @Input() custom_ticker: any;
  @Input() isMobile: boolean;
  @Input() headerdata: any;
  @Input() isWishlist: boolean;
  @Input() isSticky: boolean;
  @Input() showSecondRowHeader: boolean;
  @Input() showFirstRowHeader: boolean;
  @Input() showThirdRowHeader: boolean;
  @Input() showLogo: boolean;
  @Input() showCart: boolean;
  @Input() isSearchByVehicleDisabled: boolean = false;
  @Output() scrollToTop = new EventEmitter<void>();

  onButtonClick() {
    this.scrollToTop.emit();
  }

  constructor(
    private appConstants: AppConstants
  ) { }

  onSidebarStateChange(state: boolean) {
    this.isSidebarOpen = state;
  }
}